<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <div class="l-page__header c-page__header">
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        问题列表管理
      </h2>
      <div class="c-page__header-btns">
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm"
        />
        <k-button
          v-if="!xmId || !readOnly"
          btn-text="新增"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-plus"
          @click="openCreate"
        />
        <k-button
          v-if="xmId"
          btn-text="返回项目"
          :auth-type="false"
          @click="openNavTab({ name: 'jxxfPgxmDetail', params: { id: xmId } })"
        />
      </div>
    </div>
    <div class="l-page__item l-page--search__item">
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <el-form
          ref="filterForm"
          :model="filter"
          :inline="true"
          class="c-form c-condition__form"
          label-width="90px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              v-if="!xmId"
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filter.xmmc"
                  class="c-form__input"
                  clearable
                  placeholder="请输入项目名称"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="问题描述"
                prop="wtms"
              >
                <el-input
                  v-model.trim="filter.wtms"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="专业"
                prop="pglxDm"
              >
                <el-select
                  v-model="filter.pglxDm"
                  clearable
                >
                  <el-option
                    v-for="item in majors"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
    <div class="l-page__body l-page--search__body">
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane label="问题清单">
          <k-table
            height="100%"
            :table-column="columns"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="changePageSize"
          >
            <template #xmmc="scope">
              <el-link
                type="primary"
                @click="openProject(scope.row)"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>
            <template #wtms="scope">
              <el-link
                type="primary"
                @click="openDialog(scope.row.wtId, scope.row)"
              >
                {{ scope.row.wtms }}
              </el-link>
            </template>
            <el-table-column
              label="操作"
              width="150"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <k-button
                  :btn-text="isRowReadOnly(scope.row) ? '查看' : '编辑'"
                  :auth-type="!isRowReadOnly(scope.row)"
                  type="primary"
                  plain
                  @click="openDialog(scope.row.wtId, scope.row)"
                />
                <k-button
                  v-if="!isRowReadOnly(scope.row)"
                  btn-text="删除"
                  :auth-type="true"
                  type="danger"
                  plain
                  @click="remove(scope.row)"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      title="选择评估项目"
      :visible.sync="projectPickerVisible"
      width="520px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form
        label-width="100px"
        label-suffix="："
      >
        <el-form-item label="评估项目">
          <el-select
            v-model="selectedProjectId"
            filterable
            remote
            clearable
            style="width: 100%;"
            placeholder="请输入项目名称搜索"
            :remote-method="searchProjects"
            :loading="projectLoading"
          >
            <el-option
              v-for="item in projectOptions"
              :key="item.id"
              :label="`${item.xmmc}（${item.xmztMc || item.xmzt}）`"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="o-dialog__footer"
      >
        <k-button
          btn-text="继续新增"
          :auth-type="false"
          type="primary"
          :disabled="!selectedProjectId"
          @click="continueCreate"
        />
        <k-button
          btn-text="取消"
          :auth-type="false"
          @click="projectPickerVisible = false"
        />
      </div>
    </el-dialog>
    <issue-dialog
      v-if="dialogVisible && dialogProjectId"
      :visible="dialogVisible"
      :xm-id="dialogProjectId"
      :wt-id="currentWtId"
      :read-only="dialogReadOnly"
      @close="dialogVisible = false"
      @saved="saved"
    />
  </div>
</template>

<script>
import IssueDialog from '../pgxm/details/IssueDialog.vue';
import { pgxmManageService as pgProjectService } from '../pgxm/pgxm.service';
import { pgIssueService } from '../pgxm/details/issue.service';

export default {
  name: 'JxxfPgIssueList',
  components: { IssueDialog },
  data () {
    return {
      loading: false,
      project: {},
      dialogVisible: false,
      dialogProjectId: '',
      dialogReadOnly: false,
      projectPickerVisible: false,
      projectLoading: false,
      projectOptions: [],
      selectedProjectId: '',
      currentWtId: '',
      filter: {
        xmmc: '',
        wtms: '',
        pglxDm: ''
      },
      majors: [
        { value: 'JZFH', label: '建筑防火' },
        { value: 'XFSS', label: '消防设施' },
        { value: 'XFAQGL', label: '消防安全管理' }
      ],
      appliedFilter: {},
      page: {
        rows: [],
        total: 0,
        pageNo: 0,
        pageSize: 15
      },
      columns: [
        { key: 'index', label: '序号', width: '65', align: 'center', type: 'index' },
        { key: 'xmmc', slotName: 'xmmc', label: '项目名称', minWidth: '220', align: 'left', type: 'text' },
        { key: 'wtbh', label: '问题编号', minWidth: '170', align: 'left', type: 'text' },
        { key: 'wtms', slotName: 'wtms', label: '问题描述', minWidth: '280', align: 'left', type: 'text' },
        { key: 'pglxMc', label: '专业', minWidth: '140', align: 'left', type: 'text' },
        { key: 'jcwz', label: '具体位置', minWidth: '180', align: 'left', type: 'text' },
        { key: 'jcyj', label: '检查依据', minWidth: '220', align: 'left', type: 'text' },
        { key: 'zgjy', label: '整改建议', minWidth: '220', align: 'left', type: 'text' },
        { key: 'fjsl', label: '证据', width: '70', align: 'right', type: 'text' },
        { key: 'gljcnrsl', label: '关联内容', width: '90', align: 'right', type: 'text' },
        { key: 'dcgzsj', label: '整改时间', width: '165', align: 'center', type: 'date' }
      ]
    };
  },
  computed: {
    xmId () {
      return this.$route.params.xmId;
    },
    readOnly () {
      return !['ZXZ', 'DSC'].includes(this.project.xmzt);
    }
  },
  methods: {
    refreshSearch () {
      this.appliedFilter = Object.assign({}, this.filter);
      this.search(1);
    },
    search (pageNo = 1) {
      this.loading = true;
      const params = Object.assign({}, this.appliedFilter, {
        pageNo,
        pageSize: this.page.pageSize
      });
      if (this.xmId) params.xmId = this.xmId;
      else delete params.xmId;
      pgIssueService.page(params).then(rsp => {
        this.page = Object.assign({}, this.page, rsp.data);
      }).finally(() => {
        this.loading = false;
      });
    },
    changePageSize (pageSize) {
      this.page.pageSize = pageSize;
      this.search(1);
    },
    resetForm () {
      this.$refs.filterForm.resetFields();
      this.refreshSearch();
    },
    openCreate () {
      this.currentWtId = '';
      if (this.xmId) {
        this.dialogProjectId = this.xmId;
        this.dialogReadOnly = this.readOnly;
        this.dialogVisible = true;
        return;
      }
      this.selectedProjectId = '';
      this.projectPickerVisible = true;
      this.searchProjects('');
    },
    continueCreate () {
      if (!this.selectedProjectId) {
        this.$message.warning('请选择评估项目');
        return;
      }
      this.dialogProjectId = this.selectedProjectId;
      this.dialogReadOnly = false;
      this.projectPickerVisible = false;
      this.dialogVisible = true;
    },
    searchProjects (keyword = '') {
      this.projectLoading = true;
      Promise.all(['ZXZ', 'DSC'].map(xmzt => pgProjectService.query({
        xmmc: keyword,
        xmzt,
        pageNo: 1,
        pageSize: 20
      }))).then(responses => {
        const projects = {};
        responses.forEach(response => {
          (response.data.rows || []).forEach(item => {
            projects[item.id] = item;
          });
        });
        this.projectOptions = Object.keys(projects).map(id => projects[id]);
      }).finally(() => {
        this.projectLoading = false;
      });
    },
    openDialog (wtId = '', row = {}) {
      this.currentWtId = wtId;
      this.dialogProjectId = row.xmId || this.xmId || '';
      this.dialogReadOnly = this.isRowReadOnly(row);
      this.dialogVisible = true;
    },
    isRowReadOnly (row = {}) {
      const status = row.xmzt || this.project.xmzt;
      return !['ZXZ', 'DSC'].includes(status);
    },
    openProject (row) {
      if (row.xmId) {
        this.openNavTab({ name: 'jxxfPgxmDetail', params: { id: row.xmId } });
      }
    },
    saved () {
      this.dialogVisible = false;
      this.search(this.page.pageNo || 1);
    },
    remove (row) {
      this.$confirm(`确认删除问题“${row.wtbh}”？删除后相关不符合项可能变为未完成。`, '提示', {
        type: 'warning'
      }).then(() => pgIssueService.delete(row.wtId, row.lockVersion))
        .then(() => {
          this.$message.success('问题已删除');
          this.search(1);
        });
    }
  },
  created () {
    if (this.xmId) {
      pgProjectService.getDetail(this.xmId).then(rsp => {
        this.project = rsp.data || {};
      });
    }
    this.refreshSearch();
  }
};
</script>
